module.exports = __webpack_public_path__ + "img/twitter-x-black.dbe0e27f.svg";